import { Button, Dialog, DialogContent, Typography } from "@mui/material"
import CloseButton from "common/CloseButton"
import { logout } from "components/shopFeatures/auth/authSlice"
import { Font } from "components/shopFeatures/wizard/constants"
import { useAppDispatch, useTypedSelector } from "store"
import styled from "styled-components"

const StyledDialog = styled(Dialog)`
  .MuiDialog-paperWidthXs {
    max-width: 328px;
  }
`

const StyledDialogContent = styled(DialogContent)`
  position: relative;
  padding: ${(p) => p.theme.spacing(3)}px;
  width: 328px;

  :first-child {
    padding-top: ${(p) => p.theme.spacing(3)}px;
  }

  padding: 20px;
`

const StyledHeading = styled(Typography).attrs({ variant: "h2" })`
  text-align: center;
  margin-top: 0;
  margin-bottom: ${(p) => p.theme.spacing(3.5)}px;

  font-family: ${Font.OENaPro};
  font-size: 24px;
  font-weight: 400;
  line-height: 34px;
  letter-spacing: 0.05em;

  padding: 0 16px;
  overflow-wrap: anywhere;
`

const StyledText = styled(Typography).attrs({ variant: "body1" })`
  text-align: center;
  margin-top: 20px;
  font-family: ${Font.OENaPro};
  font-size: 16px;
  font-weight: 300;
  line-height: 22px;
  letter-spacing: 0em;
`

const StyledButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
`

const StyledButton = styled(Button)`
  :hover {
    background: ${(p) => p.theme.colors.steel};
  }
`

const SignOutDialog = ({ dialogOpen, setDialogOpen }) => {
  const { userInfo: registeredUserInfo } = useTypedSelector(
    (state) => state.auth
  )

  const dispatch = useAppDispatch()
  return (
    <StyledDialog
      open={dialogOpen}
      onClose={() => setDialogOpen(false)}
      aria-label="התחברות"
      maxWidth="xs"
      disableRestoreFocus
      classes={{ paper: "authDialog" }}
      style={{ padding: "20px" }}
    >
      <StyledDialogContent>
        <CloseButton onClick={() => setDialogOpen(false)} />
        <StyledHeading>
          {registeredUserInfo?.firstName} {registeredUserInfo?.lastName}
        </StyledHeading>

        <StyledText>
          הפרטים בעת ההתחברות מאפשרים לך לצפות בהטבות רכישה ולבצע פעולות באתר
          בקלות.
        </StyledText>
        <StyledText>האם לנתק אותך?</StyledText>
        <StyledButtonContainer>
          <StyledButton onClick={() => setDialogOpen(false)}>
            לא, השאירו אותי
          </StyledButton>
          <StyledButton
            variant="outlined"
            onClick={() => {
              setDialogOpen(false)
              setTimeout(() => dispatch(logout()), 0)
            }}
          >
            כן, נתקו אותי
          </StyledButton>
        </StyledButtonContainer>
      </StyledDialogContent>
    </StyledDialog>
  )
}

export default SignOutDialog
